import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { Box, Grid } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTipWithPermission from "../../../../../components/CustomToolTipWithPermission";
import {
  ASSET_CARD_SIZE,
  ASSET_CARD_SIZE_DIALOG,
  AutoSuggestionsSteps,
} from "../../../../../utils/constants";
import CreateNewAssetModal from "../wizard/CreateNewAssetModal";
import ContentAssetCard from "./ContentAssetCard";
import LabelInfoSection from "./LableInfoSection";

export default function SuggestionAssetCard({
  suggestion,
  fromDialog = false,
  selected = false,
  handleSelectedCard = () => {},
  hasPermission,
}) {
  const colors = useColors();
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const { trackEvent } = useAPI();

  const handleUpdateSuggestionClick = () => {
    setOpenUpdateModal(true);
    trackEvent(
      `User opened the update suggestion modal for asset ${suggestion.name} (${suggestion.asset_suggestion_id}), from the assets page`
    ).then();
  };

  const handleCloseEditModal = () => {
    setOpenUpdateModal(false);
  };

  const totalEntities = suggestion.entities_by_recommendation.reduce(
    (acc, recommendation) => acc + recommendation.entity_ids.length,
    0
  );
  return (
    <Grid container>
      <Box
        onClick={
          fromDialog
            ? handleSelectedCard
            : hasPermission
            ? handleUpdateSuggestionClick
            : null
        }
      >
        <Grid
          container
          sx={{
            width: fromDialog
              ? ASSET_CARD_SIZE_DIALOG.WIDTH
              : ASSET_CARD_SIZE.WIDTH,
            height: fromDialog
              ? ASSET_CARD_SIZE_DIALOG.HEIGHT
              : ASSET_CARD_SIZE.HEIGHT,
            padding: "16px",
            borderRadius: "16px",
            cursor: "pointer",
            border: "1.5px dashed " + colors.primary_32percent,
            justifyContent: "space-between",
            boxShadow: selected
              ? "0px 0px 4.5px 1px " + colors.asset_card_selected + " inset"
              : "0px 0px 5.3px 0px " + colors.primary_32percent,
            "&:hover": {
              boxShadow:
                "-2px 2px 2px 1px " + colors.primary_24percent + "!important",
              border: "1px solid " + colors.primary_light,
            },
          }}
        >
          <Grid item xs={10}>
            <ContentAssetCard
              asset={suggestion}
              assetType={suggestion.asset_type}
              assetName={suggestion.name}
              numEntityIds={totalEntities}
            />
          </Grid>
          {!fromDialog && (
            <CustomToolTipWithPermission
              title={null}
              permission={hasPermission}
              placement="top"
            >
              <AddCircleOutlineRoundedIcon
                sx={{
                  width: "22px",
                  color: hasPermission
                    ? colors.primary_main
                    : colors.grey_48percent,
                }}
                // TODO: Implement onClick to the button only when implementing the new modal https://linear.app/breeze-security/issue/DEV-2262/improve-asset-editing-and-wizard-ux
                //     onClick={() => handleUpdateSuggestionClick()}
              />
            </CustomToolTipWithPermission>
          )}
          {!fromDialog && (
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              <LabelInfoSection
                label={"New Auto-suggestion"}
                icon={AutoAwesomeRoundedIcon}
                infoData={"Suggestion update available. Click to confirm."}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      <CreateNewAssetModal
        open={openUpdateModal}
        onClose={handleCloseEditModal}
        steps={AutoSuggestionsSteps}
      />
    </Grid>
  );
}
